import getColor from "@insite/mobius/utilities/getColor";
import { navigationDrawerStyles } from "@WhiteCap/Overrides/Components/NavigationDrawer";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

// EC-94 : B2B Website Header
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
navigationDrawerStyles.drawer = {
    size: 300,
    cssOverrides: {
        drawerContent: css`
            margin-top: -2px;
            overflow-x: hidden;
        `,
        titleButton: css`
            padding: 0 1em;
            svg {
                color: ${WhitecapColors.createAccountHeaderBtnColor};
            }
        `,
    },
};

navigationDrawerStyles.userRowTypography = {
    transform: "uppercase",
    css: css`
        color: ${getColor("primary.main")} !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
};

navigationDrawerStyles.menuTriggerButton = {
    shape: "pill",
    color: "secondary",
    size: 50,
    css: css`
        background: black;
        border-radius: 0px;
        .menu-trigger-button-icon {
            > svg {
                color: ${WhitecapColors.createAccountHeaderBtnColor} !important;
            }
        }
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    color: "common.backgroundContrast",
    css: css`
        margin: 2px !important;
        background: transparent !important;
    `,
};

navigationDrawerStyles.shippingMessageRow = {
    color: "common.accent",
    typographyProps: {
        css: css`
            font-size: 10px;
            font-weight: 400;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 15px;
            padding-right: 15px;
            border-style: solid;
            border-width: 1px;
            border-color: #80b1fa;
        `,
    },
    css: css`
        padding-left: 30px;
        padding-bottom: 30px;
        padding-right: 30px; // EC-826 : Fixed the padding for the static message on header in mobile view
    `,
};

// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
